// Event types (stored value on each event's `type` field).
export const EVENT_TYPES = ["Tryout", "Evaluation", "Training", "Showcase", "Practice", "Tournament", "Combine", "Other"];

// Display order for dropdowns: alphabetical, with "Other" always last.
export const EVENT_TYPE_OPTIONS = ["Combine", "Evaluation", "Practice", "Showcase", "Training", "Tournament", "Tryout", "Other"];
